import { useEffect, useMemo } from 'react';

import { filter, includes } from 'lodash';

import { LabelsService } from '@/utils/services/LabelsService';

import { ADD_LABEL, REMOVE_LABEL, useAlbumContext } from '@/utils/hooks/context/useAlbumContext';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

import Icon from '@/components/base/Icon';
import Label from '@/components/base/Label';
import SelectAlbumTags from '@/components/pages/albums/AlbumFunnelModal/components/SelectAlbumTags';

const AlbumTagsFilter = ({ labelsOptions, setRequestParams }) => {
    const { t } = useTranslation('content');
    const { albumInfo, dispatch } = useAlbumContext();

    const debouncedSearch = useMemo(
        () => LabelsService.createDebouncedSearch(setRequestParams),
        [setRequestParams]
    );

    useEffect(() => {
        return () => {
            debouncedSearch?.cancel?.();
        };
    }, [debouncedSearch]);

    function addLabel(item) {
        dispatch({
            type: ADD_LABEL,
            payload: item?.label
        });
    }

    function removeLabel(item) {
        dispatch({
            type: REMOVE_LABEL,
            payload: item?.label
        });
    }

    const selectedLabels = filter(labelsOptions, (item) =>
        includes(albumInfo?.criteria?.labels, item?.label)
    );

    return (
        <div>
            <Label className="flex items-center space-x-2.5 pb-2">
                <Icon icon="labels" className="text-sm text-icoBlue" />
                <span className="text-icoBlack dark:text-white">{t('modal.labels')}</span>
            </Label>
            <SelectAlbumTags
                placeholder={t('modal.select_labels')}
                idInput="labels-search"
                options={labelsOptions}
                selectedItems={selectedLabels}
                addItem={addLabel}
                removeItem={removeLabel}
                onSearch={debouncedSearch}
            />
        </div>
    );
};

AlbumTagsFilter.propTypes = {
    labelsOptions: PropTypes.array,
    setRequestParams: PropTypes.func.isRequired
};

export default AlbumTagsFilter;
